import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SnPaymentsAPI {
  constructor(private readonly _httpClient: HttpClient) {}

  public charge(payload: any): Observable<Object> {
    return this._httpClient.post('/api/payments/charges/', payload);
  }
}
